import { render, staticRenderFns } from "./ShowMorePagination.vue?vue&type=template&id=04fb62a9&scoped=true&"
import script from "./ShowMorePagination.vue?vue&type=script&lang=ts&"
export * from "./ShowMorePagination.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMorePagination.vue?vue&type=style&index=0&id=04fb62a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb62a9",
  null
  
)

export default component.exports